import { type ReactNode } from "react";
import { Button, Stack, Typography } from "@mui/material";

export type ErrorProps = { message?: string };

export const Error = ({ message }: ErrorProps): ReactNode => {
  return (
    <Stack
      data-testid="error"
      sx={{
        gap: 1,
        textAlign: "center",
        alignItems: "center",
        justifyItems: "center",
      }}
    >
      <Typography variant="h3" component="div">
        Something went wrong
      </Typography>
      <Typography variant="h4" component="div">
        Please try refreshing the page or contact support if the issue persists.
      </Typography>
      {message && (
        <Typography variant="h6" component="div">
          {message}
        </Typography>
      )}
      <Button
        variant="contained"
        onClick={() => {
          window.location.reload();
        }}
      >
        Refresh
      </Button>
    </Stack>
  );
};
